// Material Dashboard 2 React base styles
import typography from 'assets/theme/base/typography';

function configs(labels, datasets, tooltip) {
  return {
    data: {
      labels,
      datasets: [...datasets],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        ...(tooltip && {
          tooltip,
        }),
        legend: {
          onClick: () => false,
        },
      },
      // NOTE: commented for future use
      // plugins: {
      //   legend: {
      //     display: false,
      //   },
      // },
      // scales: {
      //   y: {
      //     grid: {
      //       drawBorder: false,
      //       display: true,
      //       drawOnChartArea: true,
      //       drawTicks: false,
      //       borderDash: [5, 5],
      //     },
      //     ticks: {
      //       display: true,
      //       padding: 10,
      //       color: '#9ca2b7',
      //       font: {
      //         size: 11,
      //         family: typography.fontFamily,
      //         style: 'normal',
      //         lineHeight: 2,
      //       },
      //     },
      //   },
      //   x: {
      //     grid: {
      //       drawBorder: false,
      //       display: false,
      //       drawOnChartArea: true,
      //       drawTicks: true,
      //     },
      //     ticks: {
      //       display: true,
      //       color: '#9ca2b7',
      //       padding: 10,
      //       font: {
      //         size: 11,
      //         family: typography.fontFamily,
      //         style: 'normal',
      //         lineHeight: 2,
      //       },
      //     },
      //   },
      // },
    },
  };
}

export default configs;
